import React, { useContext } from 'react';
import AuthContext from 'context/AuthContext';
import MapZonesJS from './MapZonesJS';
import AzureMapBase from "components/maps/azure/AzureMapBase";
import AzureMapZones from './azure/AzureMapZones';


const MapZonesManager = (props) => {
    const { panel } = useContext(AuthContext);
    const provider = props.provider || panel?.map_type || panel?.map_provider || 'lf';

    switch (provider) {
        case 'az': {
            const {assets, zones, zone, polylines, azureMapsKey} = props;
            return (
                <AzureMapBase
                    center={panel.coords}
                    zoom={14}
                    height="calc(100vh - 220px)"
                    subscriptionKey={azureMapsKey}
                >
                    <AzureMapZones
                        assets={assets}
                        zones={zones}
                        editZone={zone}
                        onPolygonCreated={(coords) => {
                            if (polylines && polylines.current) {
                                polylines.current = coords;
                            }
                        }}
                        onPolygonEdited={(coords) => {
                            if (polylines && polylines.current) {
                                polylines.current = coords;
                            }
                        }}
                    />
                </AzureMapBase>
            );
        }
        case 'lf':
        default:
            return <MapZonesJS {...props} />;
    }
};

export default MapZonesManager;
